import i18n from '@app/plugins/i18n';

export function get_error(error) {
  const oops = i18n.t('shared.component.noty.error');

  try {
    const { response } = error;
    const { status } = response;
    const i18n_key = `shared.error_page.${status}.title`;

    return {
      status: response.status,
      error: response.statusText,
      message: i18n.te(i18n_key) ? i18n.t(i18n_key) : oops
    };
  } catch (e) {
    return {
      status: 500,
      error: 'Internal Server Error',
      message: oops
    };
  }
}
